import React, { useMemo } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { _deleteChatMessage } from "../../SocketIo";
import { setDeleteMessage } from "../redux/chatSlice";
import { globalStrings } from "../util/translation/languages";
import { timestampToDateTime } from "../Helpers/common";
import AttachmentFiles from "../chatboard/attachmentFile";
import { previewLinkIcon, UrlPreview } from "../Helpers/chatCommon";

const ChatDelete = (props) => {
  const { showDelete, handleClose, deleteData, userInfo, selectedLanguage } =
    props;
  const dispatch = useDispatch();
  const allAttendeeList = useSelector((state) => state.call.allAttendeeList);
  let deletedMessageIds = useSelector((state) => state.chat.deletedMessageIds);
  const deleteChatMessage = () => {
    deleteData.messageID = deleteData?.id;
    _deleteChatMessage(deleteData);
    let deletedIds = [...deletedMessageIds, deleteData?.messageID];
    dispatch(setDeleteMessage(deletedIds));
    handleClose();
  };

  const isUserOnline = useMemo(() => {
    return allAttendeeList.find((item) => item.user_id === deleteData.senderID)
      ?.online
      ? true
      : false;
  }, [allAttendeeList, deleteData.senderID]);

  let IsNewLineExist = null;
  if (deleteData.message !== "c2-attach-files") {
    IsNewLineExist = /\r|\n/.exec(deleteData.message);
  }
  const newMessage =
    IsNewLineExist !== null
      ? deleteData.preview &&
        Array.isArray(deleteData.preview) &&
        deleteData.preview.length > 0
        ? deleteData.message_array.join(" ")
        : deleteData.message.replace(/ /g, "&nbsp;")
      : deleteData.message.replace(/ /g, "&nbsp;");

  const lengthOfSplitMessage = newMessage?.split("\n").length;

  return (
    <>
      <Modal show={showDelete} className="unpin">
        <Modal.Header>
          <Modal.Title>
            {globalStrings[selectedLanguage]?.$deleteMsg}
          </Modal.Title>
          <button onClick={handleClose} className="icon-close p-0">
            <svg
              width="15.556"
              height="15.556"
              viewBox="2240.448 1762.444 15.556 15.556"
            >
              <path
                d="m2250.727 1766.055-2.5 2.5-2.5-2.5a.786.786 0 0 0-1.112 0l-.555.556a.786.786 0 0 0 0 1.11l2.5 2.5-2.5 2.501a.786.786 0 0 0 0 1.111l.555.556a.786.786 0 0 0 1.111 0l2.5-2.5 2.5 2.5a.786.786 0 0 0 1.112 0l.555-.556a.786.786 0 0 0 0-1.11l-2.5-2.501 2.5-2.5a.786.786 0 0 0 0-1.111l-.555-.556a.786.786 0 0 0-1.111 0Z"
                fill="#2d343f"
              ></path>
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div>
            <p className="text-thin">
              {globalStrings[selectedLanguage]?.$pTagDeleteMessage}
            </p>
            <div className="border border-light border-radius p-2">
              <div className="right_s w-100 ml-0">
                <div className="body p-0">
                  <div
                    className={"chat_row mb-0"}
                    id={deleteData.id}
                    key={deleteData.id}
                  >
                    <div className="w-100 d-flex max-w-100">
                      <div className="avatar">
                        {userInfo?.user_profile_image ? (
                          // eslint-disable-next-line jsx-a11y/alt-text
                          <img
                            className="h-100"
                            src={`${userInfo?.user_profile_image}`}
                          ></img>
                        ) : (
                          <svg viewBox="3 2 18 19">
                            <path
                              fill="#425b76"
                              d="M7.5 6.5C7.5 8.981 9.519 11 12 11s4.5-2.019 4.5-4.5S14.481 2 12 2 7.5 4.019 7.5 6.5zM20 21h1v-1c0-3.859-3.141-7-7-7h-4c-3.86 0-7 3.141-7 7v1h17z"
                            ></path>
                          </svg>
                        )}
                        <span
                          className={`status ${isUserOnline && "online"}`}
                        ></span>
                      </div>
                      <div
                        className={`bubble inner-bubble ${
                          deleteData.isReply === true && "reply"
                        }`}
                      >
                        {deleteData.isReply === true && (
                          <h3 className="Name-messenger">{userInfo?.name} </h3>
                        )}
                        <div
                          className={`${
                            deleteData.isReply === true && "reply-inner"
                          }`}
                        >
                          {deleteData.isReply === true ? (
                            <h3 className="Name-messenger flex-column align-items-start">
                              <div>
                                <p
                                  className="break-words text-grey"
                                  dangerouslySetInnerHTML={{
                                    __html: deleteData.earlyMessage,
                                  }}
                                />
                                <div className="time ml-0 mt-1">
                                  {allAttendeeList?.find(
                                    (findItem) =>
                                      findItem.user_id ===
                                      deleteData.earlyMsgSenderID,
                                  )?.name ?? ""}
                                  ,{" "}
                                  {timestampToDateTime(
                                    deleteData.earlyMsgTimestamp,
                                  )}
                                </div>
                              </div>
                            </h3>
                          ) : (
                            <h3 className="Name-messenger">
                              {userInfo?.name}
                              <div className="time">
                                {timestampToDateTime(deleteData.timestamp)}
                              </div>
                            </h3>
                          )}

                          {deleteData.attachments !== undefined &&
                          deleteData.attachments.length > 0 &&
                          deleteData.message === "c2-attach-files" ? (
                            <div className="d-flex file_send_info gap-10 flex-wrap">
                              {deleteData.attachments.map(
                                (attachmentItem, attachmentIndex) => (
                                  <div key={attachmentIndex} className="w-100">
                                    {/* eslint-disable-next-line indent */}
                                    {/* eslint-disable-next-line indent */}
                                    <AttachmentFiles
                                      attachmentItem={attachmentItem}
                                      messageDetail={deleteData}
                                    />
                                  </div>
                                ),
                              )}
                            </div>
                          ) : IsNewLineExist !== null ? (
                            <>
                              {newMessage?.split("\n").map((str, index) => (
                                <>
                                  <div
                                    key={index}
                                    className="d-flex file_send_info gap-10 flex-wrap"
                                  >
                                    <p
                                      className="break-words"
                                      dangerouslySetInnerHTML={{ __html: str }}
                                    />
                                    {previewLinkIcon(deleteData)}
                                    {deleteData.edited === true &&
                                      index === lengthOfSplitMessage - 1 && (
                                        <p className="edit_message_display">
                                          (edited)
                                        </p>
                                      )}
                                  </div>
                                </>
                              ))}
                              {deleteData?.preview
                                ? UrlPreview(deleteData?.preview)
                                : null}
                            </>
                          ) : (
                            <>
                              <div className="d-flex file_send_info gap-10 flex-wrap">
                                <p
                                  className="break-words"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      deleteData.preview &&
                                      Array.isArray(deleteData.preview) &&
                                      deleteData.preview.length > 0
                                        ? deleteData.message_array.join(" ")
                                        : deleteData.message,
                                  }}
                                />
                                {previewLinkIcon(deleteData)}
                                {deleteData.edited === true && (
                                  <p className="edit_message_display">
                                    (edited)
                                  </p>
                                )}
                              </div>
                              {deleteData?.preview
                                ? UrlPreview(deleteData?.preview)
                                : null}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn btn-light btn btn-secondary"
            type="cancel"
            id="cancel"
            onClick={handleClose}
          >
            {globalStrings[selectedLanguage]?.$cancel}
          </Button>
          <Button
            className="btn btn-orange btn btn-secondary"
            type="submit"
            id="submit"
            onClick={() => deleteChatMessage()}
          >
            {globalStrings[selectedLanguage]?.$delete}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ChatDelete;
